import { AbstractControl, ValidationErrors } from '@angular/forms';
import { cpf } from 'cpf-cnpj-validator';

export function cpfValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!value) return null;

  return cpf.isValid(value) ? null : { invalidCpf: true };
}
